export const GIFTING_PLANS = [
  {
    id: "monthly",
    name: "Monthly Plan",
    period: "per month",
    badge: null,
    perks: [
      "Send gifts anonymously",
      "Monthly billing",
      "Cancel anytime",
      "Full access to Anonymous Gifting",
    ],
  },
  {
    id: "lifetime",
    name: "Lifetime Plan",
    period: "one time purchase",
    badge: "Best Value",
    perks: [
      "Send gifts anonymously",
      "One-time payment",
      "No recurring charges",
      "Lifetime access",
    ],
  },
];

export const pricingForPlan = (planId, plans) =>
  (plans || []).find((plan) => plan.plan_id === planId) || null;

const captureCheckoutReturn = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("gifting_result");

    return result
      ? { result, orderId: params.get("gifting_order") }
      : null;
  } catch (e) {
    return null;
  }
};

let checkoutReturn = captureCheckoutReturn();

export const hasCheckoutReturn = () => !!checkoutReturn;

export const takeCheckoutReturn = () => {
  const value = checkoutReturn;
  checkoutReturn = null;

  return value;
};
